export default {"src":"/_next/static/media/MultiProductIcon.e352a57f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};